import * as React from 'react';
import { useSelector } from 'react-redux';

import { EMediaType, TMedia } from 'shared/components/NewbuildingGallery';
import { TourSlideContainer } from 'shared/containers/TourSlideContainer';
import { virtualTourKeySelector } from 'shared/selectors/newObject/getTour';
import { virtualTourBannerImageUrlSelector } from 'shared/selectors/newObject/getTourBannerImageUrl';

export const use3D = (): TMedia | null => {
  const tour = useSelector(virtualTourKeySelector);
  const thumbnailSrc = useSelector(virtualTourBannerImageUrlSelector);

  return React.useMemo<TMedia | null>(() => {
    if (!tour) {
      return null;
    }

    return tour && thumbnailSrc
      ? {
          type: EMediaType.Tour,
          component: <TourSlideContainer />,
          thumbnailSrc,
        }
      : null;
  }, [tour]);
};
